import { formatWithZonedDate, ServicePackageEnum } from "@repo/lib";
import { useRouteContext } from "@tanstack/react-router";
import {
  ColoredCardInfo,
  ColoredCardInfoHeader,
  ColoredCardInfoTitle,
  ColoredCardInfoDescription,
} from "@/components/colored-card-info";

export const AssistProAcceptanceTrialPeriodAlert = (): JSX.Element => {
  const { user } = useRouteContext({ strict: false });

  const proPackage = user.pacotesServicos.find(
    (servicePkg) => servicePkg.codPacoteServicos === ServicePackageEnum.Pro.valueOf(),
  );
  const trialEndDate = proPackage?.dataFimTrial;
  const formattedDate = trialEndDate
    ? formatWithZonedDate(trialEndDate, "d 'de' MMMM")
    : "";

  return (
    <ColoredCardInfo className="bg-secondary-100">
      <ColoredCardInfoHeader className="mb-1">
        <ColoredCardInfoTitle className="text-secondary-600 font-bold text-xl leading-7">
          {`Até ${formattedDate} é por nossa conta!`}
        </ColoredCardInfoTitle>
        <ColoredCardInfoDescription className="text-secondary-600">
          Para continuar no Pro, clique no botão no fim da página.
        </ColoredCardInfoDescription>
      </ColoredCardInfoHeader>
    </ColoredCardInfo>
  );
};
